import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as dayjs from "dayjs";
import { GUID_ZERO } from "src/app/utils/constants";
import { ForceSelectGuid } from "src/app/utils/force-select-guid";
import { AlertasService } from "../alertas.service";

@Component({
  selector: "app-form-alertas",
  templateUrl: "./form.component.html",
})
export class AlertasForm implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;
  public definiciones: any[] = [];
  public periodos: any[] = ["diario", "semanal", "quincenal", "mensual"];
  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  public waiting = false;
  public defaultSelect = GUID_ZERO;
  constructor(private fb: FormBuilder, private serv: AlertasService) {}

  public ngOnInit() {
    this.buildForm();
    this.serv.getDefiniciones().subscribe((s) => {
      this.definiciones = s;
    });
  }

  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
    this.waiting = false;
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
    this.form.get("IdAlertasDefinicion").enable();
    this.form.get("Periodo").enable();

    this.form.controls["IdAlertasDefinicion"].setValue(this.defaultSelect);
    this.form.controls["Periodo"].setValue(this.defaultSelect);

    this.form.controls["FechaInicio"].setValidators([Validators.required]);
    this.form.controls["FechaFinal"].setValidators([Validators.required]);
    this.waiting = false;
  }
  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    this.form.controls["IdAlertasRegistro"].setValue(
      this.defaults?.IdAlertasRegistro
    );
    this.form.controls["IdAlertasDefinicion"].setValue(
      this.defaults?.IdAlertasDefinicion
    );
    this.form.controls["Periodo"].setValue(this.defaults?.Periodo);

    this.form.get("IdAlertasDefinicion").disable();
    this.form.get("Periodo").disable();

    this.form.controls["Correos"].setValue(this.defaults?.Correos);
    this.form.controls["FechaInicio"].patchValue(
      this.defaults.FechaIngreso
        ? dayjs(this.defaults.FechaIngreso).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["FechaFinal"].patchValue(
      this.defaults.FechaIngreso
        ? dayjs(this.defaults.FechaIngreso).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["FechaInicio"].clearValidators();
    this.form.controls["FechaFinal"].clearValidators();
    this.waiting = false;
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.waiting = true;
    const data = this.form.value;
    this.onsave.emit({ mode: this.mode, value: { ...data } });
  }

  public update() {
    this.waiting = true;
    const data = this.form.value;
    this.onsave.emit({ mode: this.mode, value: { ...data } });
  }
  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  private buildForm() {
    this.form = this.fb.group({
      IdAlertasRegistro: [""],
      IdAlertasDefinicion: [this.defaultSelect, ForceSelectGuid()],
      Periodo: [this.defaultSelect, [Validators.required, ForceSelectGuid()]],
      Correos: ["", [Validators.required]],
      FechaInicio: ["", [Validators.required]],
      FechaFinal: ["", [Validators.required]],
    });
  }
  public setWaiting(value: boolean) {
    this.waiting = value;
  }
}
